import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  remoteOpen: boolean;
}

export const remoteOpen = async <V>(
  apollo: DollarApollo<V>,
  roomId: string
): Promise<FetchResult<RawResult>> => {
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: { roomId },
    update(_proxy, data): boolean {
      return data.data!.remoteOpen;
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
